<script lang="ts" setup>
import { useService } from '@kaokei/use-vue-service';
import avatarPng from '~/assets/image/avatar@2x.png';
import CommonFooter from '~/components/CommonFooter.vue';
import HTSelectZoneAdmin from '~/components/HTSelectZoneAdmin.vue';
import { RouterService } from '~/services/router.service';
import { UserService } from '~/services/user.service';
import { PERM, PERMS } from '~/utils/permission';

const userService = useService(UserService);
const routerService = useService(RouterService);

const handleLogout = async () => {
  userService.reset();
  routerService.reload();
};
</script>

<template>
  <a-layout>
    <header class="z-10 flex h-12 w-full items-center bg-white px-8 shadow-sm">
      <NuxtLink to="/admin" class="-ms-4 flex items-center px-4 py-1">
        <img class="h-8" src="~/assets/image/logo@2x.png" alt="logo" />
        <span class="ml-2 text-lg text-title">后台管理</span>
      </NuxtLink>

      <div class="ml-auto flex items-center gap-2">
        <NuxtLink
          v-if="false"
          v-auth="PERM.SIMULAR_MANAGER"
          to="/admin/clouddesktop"
          class="link-btn"
        >
          云桌面管理
        </NuxtLink>
        <NuxtLink
          v-auth="PERM.GET_ALL_SUBMIT_LIST"
          to="/admin/submission"
          class="link-btn"
        >
          全部提交
        </NuxtLink>
        <NuxtLink
          v-auth="PERM.QUALITY_CONTROL"
          to="/admin/community/solution"
          class="link-btn"
        >
          内容管理
        </NuxtLink>
        <NuxtLink
          v-auth="PERM.GET_ALL_PROBLEM_LIST"
          to="/admin/problem/list"
          class="link-btn"
        >
          全部题目
        </NuxtLink>
        <NuxtLink
          v-auth="PERM.SELECT_WAREHOUSE_LIST"
          to="/admin/warehouse/list"
          class="link-btn"
        >
          题库
        </NuxtLink>
        <NuxtLink
          v-auth="PERM.SELECT_TRAINING_LIST"
          to="/admin/training/list"
          class="link-btn"
        >
          题单
        </NuxtLink>
        <NuxtLink
          v-auth="PERM.SELECT_CONTEST_LIST"
          to="/admin/contest/list"
          class="link-btn"
        >
          比赛
        </NuxtLink>
        <NuxtLink
          v-auth="PERM.ROOT_AUTH"
          to="/admin/group/list"
          class="link-btn"
        >
          小组
        </NuxtLink>
        <NuxtLink
          v-auth="PERM.SELECT_USER_LIST"
          to="/admin/user"
          class="link-btn"
        >
          用户
        </NuxtLink>
        <NuxtLink
          v-auth="PERMS.SELECT_TAG_LIST"
          to="/admin/tag/list"
          class="link-btn"
        >
          标签
        </NuxtLink>

        <a-dropdown
          v-if="userService.hasAuth(PERMS.CREATE_ALL)"
          placement="bottomRight"
          class="flex items-center"
        >
          <div class="cursor-pointer px-1 py-1">
            创建
            <CaretDownOutlined />
          </div>

          <template #overlay>
            <a-menu>
              <a-menu-item v-if="userService.hasAuth(PERM.CREATE_WAREHOUSE)">
                <NuxtLink
                  to="/admin/warehouse/create"
                  class="flex items-center rounded-md text-left"
                >
                  创建题库
                </NuxtLink>
              </a-menu-item>
              <a-menu-item v-if="userService.hasAuth(PERM.CREATE_TRAINING)">
                <NuxtLink
                  to="/admin/training/create"
                  class="flex items-center rounded-md text-left"
                >
                  创建题单
                </NuxtLink>
              </a-menu-item>
              <a-menu-item v-if="userService.hasAuth(PERM.CREATE_CONTEST)">
                <NuxtLink
                  to="/admin/contest/create"
                  class="flex items-center rounded-md text-left"
                >
                  创建比赛
                </NuxtLink>
              </a-menu-item>
              <a-menu-item v-if="userService.hasAuth(PERM.ROOT_AUTH)">
                <NuxtLink
                  to="/admin/group/create"
                  class="flex items-center rounded-md text-left"
                >
                  创建小组
                </NuxtLink>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>

        <a-dropdown
          v-if="userService.hasAuth(PERM.ROOT_AUTH)"
          placement="bottomRight"
          class="flex items-center"
        >
          <div class="cursor-pointer px-1 py-1">
            <span class="ml-1">激励</span>
            <CaretDownOutlined />
          </div>

          <template #overlay>
            <a-menu>
              <a-menu-item>
                <NuxtLink
                  to="/admin/incentive/mission/normal"
                  class="flex items-center rounded-md text-left"
                >
                  任务管理
                </NuxtLink>
              </a-menu-item>
              <a-menu-item>
                <NuxtLink
                  to="/admin/incentive/reward/badge"
                  class="flex items-center rounded-md text-left"
                >
                  奖励配置
                </NuxtLink>
              </a-menu-item>
              <a-menu-item v-if="false">
                <NuxtLink
                  to="/admin/incentive/level"
                  class="flex items-center rounded-md text-left"
                >
                  等级管理
                </NuxtLink>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>

        <a-dropdown
          v-if="userService.hasAuth(PERMS.INDEX_CONFIG)"
          placement="bottomRight"
          class="flex items-center"
        >
          <div class="cursor-pointer px-1 py-1">
            <span class="ml-1">首页配置</span>
            <CaretDownOutlined />
          </div>

          <template #overlay>
            <a-menu>
              <a-menu-item
                v-if="userService.hasAuth(PERM.SELECT_DISCUSSION_LIST)"
              >
                <NuxtLink
                  to="/admin/indexconfig/article"
                  class="flex items-center rounded-md text-left"
                >
                  核桃精选
                </NuxtLink>
              </a-menu-item>
              <a-menu-item v-if="userService.hasAuth(PERM.SELECT_BANNER_LIST)">
                <NuxtLink
                  to="/admin/indexconfig/banner"
                  class="flex items-center rounded-md text-left"
                >
                  首页Banner
                </NuxtLink>
              </a-menu-item>
              <a-menu-item v-if="userService.hasAuth(PERM.ROOT_AUTH)">
                <NuxtLink
                  to="/admin/indexconfig/contest"
                  class="flex items-center rounded-md text-left"
                >
                  热门赛事
                </NuxtLink>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>

        <HTSelectZoneAdmin v-if="userService.isAdmin()" />

        <a-dropdown placement="bottomRight" class="flex items-center">
          <div class="cursor-pointer">
            <a-avatar
              size="small"
              class="!border-zinc-100"
              :src="userService.user.avatar || avatarPng"
              alt="avatar"
            />
            <span class="ml-1 max-w-24 truncate">{{
              userService.user.nickname
            }}</span>
          </div>

          <template #overlay>
            <a-menu class="w-32">
              <a-menu-item>
                <NuxtLink to="/" class="flex items-center rounded-md text-left">
                  公共首页
                </NuxtLink>
              </a-menu-item>
              <a-menu-divider />
              <a-menu-item>
                <NuxtLink
                  to="/oj/home"
                  class="flex items-center rounded-md text-left"
                >
                  我的主页
                </NuxtLink>
              </a-menu-item>
              <a-menu-item>
                <NuxtLink
                  to="/oj/profile"
                  class="flex items-center rounded-md text-left"
                >
                  个人信息
                </NuxtLink>
              </a-menu-item>
              <a-menu-divider />
              <a-menu-item>
                <a href="javascript:;" @click="handleLogout">登出</a>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
    </header>

    <a-layout-content class="!min-h-hcontent">
      <slot></slot>
    </a-layout-content>

    <a-layout-footer class="mt-[70px] !bg-white !px-0 !py-[30px] text-center">
      <CommonFooter />
    </a-layout-footer>
  </a-layout>
</template>

<style scoped>
.link-btn {
  @apply flex items-center rounded-md px-4 py-1 hover:bg-hover;
}
</style>
